import SearchApi from '../api/routes/SearchApi';
import PropertySearchModel from '../api/models/PropertySearchModel';
import PropertySearchResult from '../interfaces/property/PropertySearchResult';

const fetchSearchProperty = async (
    searchText: string,
    currentPage: number,
    pageSize: number,
    propertyTypeIds: Array<number>,
    countryIds: Array<number>
): Promise<PropertySearchResult & { totalCount: number; items: any[] }> => {
    let searchParams = new PropertySearchModel(searchText, propertyTypeIds, countryIds, currentPage, pageSize);
    try {
        const response = await SearchApi.fetchSearchProperty(searchParams);
        const data = response?.data as any;
        const items = data?.items ?? [];
        const total = data?.totalCount ?? data?.totalcount ?? items.length;
        return { ...data, items, totalCount: total, totalcount: total };
    } catch {
        return { items: [], totalCount: 0, totalcount: 0 } as PropertySearchResult & { totalCount: number; items: any[] };
    }
};

const fetchHomePropertyAssets = async (top: number): Promise<PropertySearchResult> => {
    const response = await SearchApi.fetchHomePagePropertyAssets(top);
    return response?.data;
};

const SearchService = {
    fetchSearchProperty,
    fetchHomePropertyAssets,
};

export default SearchService;
